import React from 'react';

const OM = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_75"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_75)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#DE0F09"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10H21V15H6V10Z"
        fill="#008100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99999 0H21V5H5.99999V0ZM4.57599 3.903C4.52099 3.986 4.45799 4.063 4.38599 4.136C3.79899 4.722 2.84899 4.722 2.26399 4.136C1.67799 3.551 1.67799 2.601 2.26399 2.016C2.33599 1.942 2.41399 1.879 2.49699 1.824C2.27199 2.244 2.45699 2.916 2.97099 3.429C3.48499 3.941 4.15599 4.127 4.57699 3.902L4.57599 3.903Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.424 3.903C2.479 3.986 2.542 4.063 2.614 4.136C3.201 4.722 4.151 4.722 4.736 4.136C5.322 3.551 5.322 2.601 4.736 2.016C4.664 1.942 4.586 1.879 4.503 1.824C4.728 2.244 4.543 2.916 4.029 3.429C3.515 3.941 2.844 4.127 2.423 3.902L2.424 3.903Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default OM;
